module.exports = __webpack_public_path__ + "static/media/grabaseat5.b51b575d.jpg";